import { render, staticRenderFns } from "./UsePortraitScreen.vue?vue&type=template&id=760ba71e&scoped=true&"
import script from "./UsePortraitScreen.vue?vue&type=script&lang=js&"
export * from "./UsePortraitScreen.vue?vue&type=script&lang=js&"
import style0 from "./UsePortraitScreen.vue?vue&type=style&index=0&id=760ba71e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ba71e",
  null
  
)

export default component.exports